export default "__VITE_ASSET__ft1r8JMX__"